import styled from 'styled-components'

export const Wrapper = styled.div`
  border-top: 1px solid #b7b8c1;
  padding-top: 12px;
  display: flex;
  flex-flow: row wrap;
`

export const Parameter = styled.div`
  margin: 0 16px 8px 1px;
`

export const Value = styled.div`
  font-weight: 500;
  font-size: 9px;
  line-height: 140%;
  color: #121432;
  white-space: nowrap;
`

export const Label = styled.div`
  font: var(--typography-8-10-bold);
  color: #717284;
  white-space: nowrap;
`
